import * as React from 'react';
import {
    USUARIO_STORAGE_KEY,
    SESSION_TIMEOUT_MS,
    endSessionLocalInactivity,
} from '../services/sessionEnd';

export const AuthContext = React.createContext({});

export const AuthContextConsumer = AuthContext.Consumer;

export class AuthContextProvider extends React.Component {
    idleTimer = null;

    updateUsuario = (usuario) => {
        if (usuario) {
            usuario.date = new Date().toString();
            window.localStorage.setItem(USUARIO_STORAGE_KEY, JSON.stringify(usuario));
        } else {
            window.localStorage.removeItem(USUARIO_STORAGE_KEY);
        }

        this.setState({ usuario });
    }

    state = {
        usuario: JSON.parse(window.localStorage.getItem(USUARIO_STORAGE_KEY)) || null,
        updateUsuario: this.updateUsuario
    }

    checkLoginTimeout = (renewIfActive = false) => {
        const usuarioLS = JSON.parse(window.localStorage.getItem(USUARIO_STORAGE_KEY));
        const tiempoTranscurrido = usuarioLS?.date
            ? (new Date() - new Date(usuarioLS.date))
            : Number.MAX_SAFE_INTEGER;

        if (!usuarioLS) {
            if (this.state.usuario) {
                this.setState({ usuario: null });
            }
            return;
        }

        if (tiempoTranscurrido > SESSION_TIMEOUT_MS) {
            endSessionLocalInactivity();
            this.setState({ usuario: null });
            return;
        }

        if (renewIfActive) {
            this.updateUsuario(usuarioLS);
        } else if (!this.state.usuario) {
            this.setState({ usuario: usuarioLS });
        }
    }

    componentDidMount() {
        this.checkLoginTimeout(false);

        window.onclick = () => {
            this.checkLoginTimeout(true);
        };

        this.idleTimer = window.setInterval(() => {
            this.checkLoginTimeout(false);
        }, 60 * 1000);
    }

    componentWillUnmount() {
        if (this.idleTimer) {
            window.clearInterval(this.idleTimer);
        }
        if (window.onclick) {
            window.onclick = null;
        }
    }

    render() {
        const { children } = this.props;

        return (
            <AuthContext.Provider
                value={{
                    ...this.state,
                }}
            >
                {children}
            </AuthContext.Provider>
        );
    }
}
